import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { CampaignCardForm } from './CampaignCardForm'
import { ActionsType } from './types'

const formName = 'add-campaign-form'

type Props = Omit<ActionsType, 'sequence' | 'leadId'>

export const AddCampaign = ({ ...props }: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      width={800}
      title={t('lead.campaigns')}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.save')}
      okButtonProps={{
        htmlType: 'submit',
        form: formName
      }}
      {...props}
    >
      <CampaignCardForm formName={formName} closeModal={props.onCancel} />
    </Modal>
  )
}
